import { SharedState } from '$utils/sharedState.svelte';
import type { NotificationPermission } from '$types/notificationPermission';

class StateNotificationsPermissions extends SharedState<NotificationPermission> {}

export const stateNotificationsPermissions = new StateNotificationsPermissions(null);
